import { render, staticRenderFns } from "./SvgWidget.vue?vue&type=template&id=c56e98e4&scoped=true&"
import script from "./SvgWidget.vue?vue&type=script&lang=js&"
export * from "./SvgWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56e98e4",
  null
  
)

export default component.exports